import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DocumentMaster} from '../models/document-master';

@Component({
  selector: 'document-detail',
  template: `
    <div class="row line-item">
      <div class="col-md-5">
        <div class="row">
          <div class="col-md-2">
            {{doc.id}}
          </div>
          <div class="col-md-9">
            <div><label>{{doc.title}}</label></div>
            <div class="small">{{doc.description}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <a class="action-link" (click)="delete(doc.id)">
              <i class="fa fa-trash"></i>
              <span>Delete</span>
            </a>
            <a class="action-link" (click)="edit(doc.id)">
              <i class="fa fa-pencil"></i>
              <span>Edit</span>
            </a>
            <span *ngIf="downloading === doc.id" class="action-link">
              <i class="fa fa-download"></i>
              <span >Downloading</span>
            </span>
            <a *ngIf="downloading !== doc.id" class="action-link" (click)="download(doc.fileId)">
              <i class="fa fa-download"></i>
              <span >Download</span>
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-2 small">
        <div>{{doc.filename}}</div>
        <div>{{doc.sizeString}}</div>
      </div>
      <div class="col-md-5 small">
        <div class="row">
          <div class="col-md-6 text-right">
            <label>Created:</label>
          </div>
          <div class="col-md-6">
            <div>{{doc.created | date: 'MM/dd/yyyy': 'UTC'}}</div>
            <div>{{doc.createdBy}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 text-right">
            <label>Last Updated:</label>
          </div>
          <div class="col-md-6">
            <div>{{doc.lastUpdate | date: 'MM/dd/yyyy': 'UTC'}}</div>
            <div>{{doc.lastUpdateBy}}</div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
  .action-link {
    margin:0px 6px 0px 6px;
    font-size:.7rem!important;
    display:inline-block;
  }
  `]
})
export class DocumentDetailComponent {
  @Input() doc: DocumentMaster;
  @Input() allowDelete: boolean;
  @Input() downloading: number;
  @Output() downloadFile: EventEmitter<number> = new EventEmitter();
  @Output() deleteFile: EventEmitter<number> = new EventEmitter();
  @Output() editFile: EventEmitter<number> = new EventEmitter();

  download(id: number) {
    this.downloadFile.emit(id);
  }

  delete(id: number) {
    this.deleteFile.emit(id);
  }

  edit(id: number) {
    this.editFile.emit(id);
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/components/document-detail.ts